import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { Loading } from './Common/Loading';
import { Provider, useSelector } from 'react-redux';
import { store } from './redux/store';
import AppDownload from './Common/AppDownload';

const RootComponent = () => {
  const loader = useSelector((state) => state?.Loader?.Loader);

  return (
    <>
      {loader && <Loading />}
      <ToastContainer />
      <App />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <AppDownload
      playStoreUrl="https://play.google.com/store/apps/details?id=youth.ncert.papergeneration"
      appStoreUrl="https://apps.apple.com/in/app/youth-paper-generation-1-to-12/id6497714615"
    />
    <Provider store={store} >
      <RootComponent />
    </Provider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
